/* eslint-disable quotes */
/* eslint-disable object-curly-newline */
import React, { useState, useEffect } from "react";
import { Row, Col, Input, Form, Button } from "antd";
import PropTypes from "prop-types";
import UploaderComponent from "../UploaderComponent/UploaderComponent";
import { imagesArrayToFiles } from "../../utils/data/imagesUrlsToArray";
import "./HeroSliderForm.less";

const HeroSlider = (props) => {
  const { form, action, deleteAction, token, isEdit, data } = props;
  const [smImage, setSmImage] = useState("");
  const [mdImage, setMdImage] = useState("");
  const [lgImage, setLgImage] = useState("");

  const { getFieldDecorator, validateFields } = form;

  const handleRemoveImage = (size) => {
    switch (size) {
      case "smImage":
        setSmImage("");
        break;
      case "mdImage":
        setMdImage("");
        break;
      case "lgImage":
      default:
        setLgImage("");
        break;
    }
  };

  const isImagesLoaded = () => smImage.length > 0 && mdImage.length > 0 && lgImage.length > 0;

  const sendData = (edit = false) => {
    validateFields((err, values) => {
      if (!err) {
        const payload = {
          ...values,
          img_s: smImage,
          img_m: mdImage,
          img_l: lgImage,
          edit,
        };
        action(payload);
      }
    });
  };

  useEffect(() => {
    if (isImagesLoaded() && isEdit) {
      sendData(true);
    }
  }, [smImage, mdImage, lgImage]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isImagesLoaded()) sendData();
  };

  const handleDelete = (e) => {
    e.preventDefault();
    validateFields((err, values) => {
      const { campaign } = values;
      deleteAction(campaign);
    });
  };

  return (
    <div className="hero-tool-container">
      <Form>
        <Row>
          <Col span={8}>
            <div className="px10">
              <Form.Item label="Campaña">
                {getFieldDecorator("campaign", {
                  rules: [
                    {
                      required: true,
                      message: "Identificador de campaña requerido",
                    },
                  ],
                })(<Input />)}
              </Form.Item>
            </div>
          </Col>
          <Col span={16}>
            <div className="px10">
              <Form.Item label="URL Oferta">
                {getFieldDecorator("click_out", {
                  rules: [
                    {
                      required: true,
                      message: "URL de la Oferta (Clockout)",
                    },
                  ],
                })(<Input />)}
              </Form.Item>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <div className="px10">
              <Form.Item>
                <UploaderComponent
                  customClassName="example-images-list"
                  listType="picture"
                  limit={1}
                  handleImage={(image) => {
                    setSmImage(image.url);
                  }}
                  handleOnRemove={() => {
                    handleRemoveImage("smImage");
                  }}
                  label="Imagen Pequeña"
                  token={token}
                  type={2}
                  method="post"
                  images={data.img_s ? imagesArrayToFiles([data.img_s]) : []}
                />
                {getFieldDecorator("smImage", {})(<Input hidden />)}
              </Form.Item>
            </div>
          </Col>
          <Col span={8}>
            <Form.Item>
              <UploaderComponent
                customClassName="example-images-list"
                listType="picture"
                limit={1}
                handleImage={(image) => {
                  setMdImage(image.url);
                }}
                handleOnRemove={() => {
                  handleRemoveImage("mdImage");
                }}
                label="Imagen Mediana"
                token={token}
                type={2}
                method="post"
                images={data.img_m ? imagesArrayToFiles([data.img_m]) : []}
              />
              {getFieldDecorator("mdImage", {})(<Input hidden />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item>
              <UploaderComponent
                customClassName="example-images-list"
                listType="picture"
                limit={1}
                handleImage={(image) => {
                  setLgImage(image.url);
                }}
                handleOnRemove={() => {
                  handleRemoveImage("lgImage");
                }}
                label="Imagen Grande"
                token={token}
                type={2}
                method="post"
                images={data.img_l ? imagesArrayToFiles([data.img_l]) : []}
              />
              {getFieldDecorator("lgImage", {})(<Input hidden />)}
            </Form.Item>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          {!deleteAction && (
            <Button type="primary" onClick={handleSubmit}>
              Agregar Hero
            </Button>
          )}
          {deleteAction && (
            <Button type="danger" onClick={handleDelete}>
              Borrar Hero
            </Button>
          )}
        </Row>
      </Form>
    </div>
  );
};

HeroSlider.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
  deleteAction: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object,
  isEdit: PropTypes.bool,
};

HeroSlider.defaultProps = {
  data: null,
  isEdit: false,
};
const HeroSliderForm = Form.create({
  name: "heroSliderForm",
  mapPropsToFields(props) {
    return {
      campaign: Form.createFormField({
        ...props.data,
        value: props.data.campaign,
      }),
      click_out: Form.createFormField({
        ...props.data,
        value: props.data.click_out,
      }),
    };
  },
})(HeroSlider);

export default HeroSliderForm;
